<template>
  <div class="wrap">
    <div class="order-item allocated" v-if="info.workOrderId">
      <!-- 时间转交 头像名称-->
      <header class="head">
        <div class="hospital-info z-flex">
          <div class="hospital z-flex-l">
            <a-avatar
              v-if="info.hospitalFollowUrl"
              class="hospital-avatar"
              :size="24"
              :src="info.hospitalFollowUrl"
              shape="square"
              alt="医院图片"
            />
            <a-tooltip>
              <template #title>{{ info.hospitalFollowName }}</template>
              <div v-if="info.hospitalFollowName" class="hospital-name">
                {{ info.hospitalFollowName }}
              </div>
            </a-tooltip>
          </div>
          <div class="createAt">
            {{ info.createAt ? formatTime(moment(info.createAt).valueOf()) : '' }}
          </div>
        </div>
        <!-- 头像 -->
        <div class="z-flex">
          <a-avatar
            class="avatar"
            :size="36"
            :src="info.heardUrl || imgs[info.beRemindedType - 1]"
            shape="square"
            alt="头像"
          />
          <div class="order-info z-flex">
            <div class="id-time z-flex-c">
              <div class="name-info">
                <span class="name">
                  {{ info.reminder }}
                </span>
                <roles :solerType="info.beRemindedType" />
              </div>
              <div class="order-flag times" v-if="info.allocatedNum > 1">
                分配+{{ info.allocatedNum }}
              </div>
            </div>
            <div class="order-id z-flex">
              <text>工单ID : {{ info.workOrderId }}</text>
              <auth-img class="copy" :src="copy" @click="handleCopy(info.workOrderId)" />
            </div>
          </div>
        </div>
      </header>
      <!-- 工单信息 -->
      <div class="work-info">
        <auth-img
          src="@/assets/img/work-place/lin-guan.png"
          alt="临观标签"
          v-if="info.activityFlag"
        />
        <span class="guideInquiry" v-if="info.workOrderType === 10">导诊</span>
        <div
          v-html="brightenKeyword(info)"
          class="workdec"
          @click="handleDetail"
          :class="{ pointer: info.serialNumber || info.reserveSn }"
        ></div>
      </div>
      <!-- 底部按钮区域 -->
      <div class="foot-line z-flex">
        <div class="btns">
          <a-button
            class="button"
            @click.stop="openTransfer(info)"
            type="primary"
            ghost
            :disabled="info.stateTag === 1 || info.stateTag === 3"
          >
            转交
          </a-button>
          <a-button class="button" type="primary" @click="beforeDoingItNow()">处理</a-button>
        </div>
      </div>
    </div>
    <div v-else class="empty">
      <img src="~@/assets/img/empty.png" />
      <div>暂无待处理工单</div>
      <a-button @click="doReceiveOrder" type="primary" class="btn" size="large">领取工单</a-button>
    </div>
    <div class="order-item will-allocate" v-if="waitList.length">
      <div class="title">等候分配的工单</div>
      <div class="will-allocate-list" v-for="item in waitList" :key="item.workOrderId">
        <div class="hospital-info z-flex">
          <div class="hospital z-flex-l">
            <a-avatar
              v-if="item.hospitalFollowUrl"
              class="hospital-avatar"
              :size="24"
              :src="item.hospitalFollowUrl"
              shape="square"
              alt="医院图片"
            />
            <a-tooltip>
              <template #title>{{ item.hospitalFollowName }}</template>
              <div v-if="item.hospitalFollowName" class="hospital-name">
                {{ item.hospitalFollowName }}
              </div>
            </a-tooltip>
          </div>
          <span class="createAt">
            {{ item.createAt ? formatTime(moment(item.createAt).valueOf()) : '' }}
          </span>
        </div>
        <div class="z-flex">
          <div class="order-id z-flex">
            <text>ID：{{ item.workOrderId }}</text>
            <auth-img class="copy" :src="copy" @click="handleCopy(item.workOrderId)" />
          </div>
        </div>
        <div class="z-flex-c work-type">
          <span class="work-type-name">{{ item.workOrderTypeDesc }}</span>
          <div>
            <span class="order-flag times" v-if="item.allocatedNum > 1">
              分配+{{ item.allocatedNum }}
            </span>
            <span class="order-flag answer" v-if="item.transferFlag">转交工单</span>
            <span class="order-flag answer" v-if="item.patientReplyFlag">患者回复</span>
            <span class="order-flag answer" v-if="item.relationFlag">关联工单</span>
          </div>
        </div>
        <div class="work-info">{{ item.workOrderTask }}</div>
      </div>
    </div>
    <the-detail
      v-model:visible="detail.detailVisible"
      :serialNumber="detail.serialNumber"
      :recordType="detail.recordType"
    />
    <ADetail ref="aDetail" :reserveSn="appointId" />
  </div>
</template>
<script setup>
import { defineEmits, defineProps, nextTick, reactive, ref, computed, createVNode } from 'vue'
import {
  handleOrder,
  receiveWorkOrder,
  subTaskPopWindow,
  beforeHandleOrder
} from '@/api/workPlace/workOrder'
import { useStore } from 'vuex'
import { formatTime, handleCopy, subStringToType, brightenKeyword } from '@/utils'
import moment from 'moment'
import { handleWorkStatus } from '@/views/WorkPlace/hooks/workOrder'
import EventBus from '@/utils/EventBus.js'
import copy from '@/assets/img/work-place/copy.png'
import TheDetail from '@/components/TheDetail/index.vue'
import ADetail from '@/views/WorkPlace/components/Appoint/index.vue'
import { Modal } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { computeGroupId } from './hooks/useGroupOrder'
import { REFRESH_LIST, INIT_ORDER_SORT_STATUS } from '@/views/WorkPlace/handleEventBuss'
const store = useStore()
const emit = defineEmits(['doPendingItNow', 'openTransfer', 'openDetail', 'receiveOrder'])
const prop = defineProps({
  data: {
    type: Object,
    required: true,
    default: () => {}
  }
})
const info = computed(() => prop.data?.pendingWorkOrder || {})
const waitList = computed(() => prop.data?.waitingForAllotWorkOrderList || [])

// 处理工单前校验是否需要回滚
const beforeDoingItNow = async () => {
  const { success, msgTitle, msgContent } = await beforeHandleOrder({
    workOrderId: info.value.workOrderId
  })
  if (!success) {
    Modal.confirm({
      title: msgTitle,
      icon: createVNode(ExclamationCircleOutlined),
      content: msgContent,
      okText: '确定',
      centered: true,
      onOk: () => {
        doPendingItNow()
      }
    })
  } else {
    doPendingItNow()
  }
}
// 立即处理
async function doPendingItNow() {
  handleWorkStatus()
    .then(async () => {
      //防止重复监听
      EventBus.off('memberJoinPublicGroupSuccess')
      const workOrderId = info.value.workOrderId
      const workOrderType = info.value.workOrderType
      const { ifPopUpTag, message } = await subTaskPopWindow({ workOrderId })
      if (ifPopUpTag && workOrderType === 33) {
        // 提醒弹窗
        Modal.info({
          title: '系统提醒',
          icon: createVNode(ExclamationCircleOutlined),
          content: message,
          okText: '知道了',
          centered: true,
          onOk: () => {
            store.commit('workOrder/SET_NEED_REFRESH')
          }
        })
      } else {
        const {
          groupId,
          guideConsultGroupId,
          doctorDaGroupId,
          privateGroupId,
          tipMessage,
          code,
          msg
        } = await handleOrder({ workOrderId })
        const defaultId = computeGroupId(
          guideConsultGroupId,
          groupId,
          doctorDaGroupId,
          privateGroupId
        )
        // 待处理中点击处理为自动完成
        if (code && code === '4000') {
          judgeAutocomplete(msg)
        } else {
          if (tipMessage) {
            checkOrderStatus(tipMessage)
          } else {
            // 初始化处理中的筛选条件
            INIT_ORDER_SORT_STATUS?.emit()
            store.commit('workOrder/SET_CHART_ID', defaultId)
            emit('doPendingItNow')
            try {
              store.dispatch('user/queryShiftStaus')
              store.dispatch('rollBack/getAllRefreshTimer')
            } catch (error) {
              console.log(error)
            }
          }
        }
      }
    })
    .catch(() => {
      REFRESH_LIST?.emit()
    })
}
//待提醒人类型：0：患者，1：医生
const imgs = [
  require('@/assets/img/chat/head_p.png'),
  require('@/assets/img/chat/head_d.png'),
  require('@/assets/img/chat/head_a.png')
]
//工单处理判断自动完成
const judgeAutocomplete = autoCompleteTipMessage => {
  Modal.warning({
    title: '工单自动完成关闭提醒',
    icon: createVNode(ExclamationCircleOutlined),
    content: autoCompleteTipMessage,
    okText: '知道了',
    centered: true,
    onOk: () => {
      REFRESH_LIST?.emit()
    }
  })
}
// 查看当前工单状态
const checkOrderStatus = tipMessage => {
  Modal.confirm({
    title: '工单未处理提示',
    icon: createVNode(ExclamationCircleOutlined),
    content: tipMessage,
    okText: '知道了',
    centered: true,
    onOk: () => {
      REFRESH_LIST?.emit()
      emit('receiveOrder')
    }
  })
}

function openTransfer(info) {
  emit('openTransfer', info)
}

const detail = reactive({
  // the detail
  detailVisible: false,
  serialNumber: '',
  recordType: ''
})
// 复诊预约
const aDetail = ref(null)
const appointId = ref('')

// 查看处方单、预约单详情
const handleDetail = () => {
  const { serialNumber, workOrderType, reserveSn } = info.value
  if (workOrderType === 7) {
    if (!reserveSn) return
    appointId.value = reserveSn
    nextTick(() => {
      aDetail.value.mVisible = true
      aDetail.value.initDetail()
    })
  } else {
    if (!serialNumber) return
    detail.serialNumber = serialNumber
    detail.recordType = subStringToType(serialNumber)
    detail.detailVisible = true
  }
}
// 领取工单
const doReceiveOrder = () => {
  receiveWorkOrder().then(() => {
    emit('receiveOrder')
  })
}
// 显示医院全称的工单Id数组
const showFullNameArr = ref([])
// 控制医院名称是否显示全称
const handleFullName = workOrderId => {
  // 判断当前工单是否显示医院全称
  const index = showFullNameArr.value.indexOf(workOrderId)
  // 若当前工单并未显示医院全称，则展示全称
  // 若当前工单已显示医院全称，则省略全称
  index === -1 ? showFullNameArr.value.push(workOrderId) : showFullNameArr.value.splice(index, 1)
}
</script>
<style lang="scss" scoped>
.wrap {
  background: white;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
}
.empty {
  text-align: center;
  border-bottom: 1px solid #e8e8e8;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  .btn {
    margin: 20px 0;
  }
}
.order-item {
  padding: 12px;
  &.allocated {
    border-bottom: 1px solid #e8e8e8;
  }

  justify-content: flex-start;
  .head {
    margin-bottom: 12px;
    .hospital-info {
      margin-bottom: 12px;
      align-items: flex-start;
      justify-content: space-between;

      .hospital {
        align-items: flex-start;
        flex: 1;
        overflow: hidden;
        cursor: pointer;
        .hospital-avatar {
          margin-right: 6px;
        }
        .hospital-name {
          flex: 1;
          font-size: 14px;
          font-weight: bold;
          color: #495d87;
          line-height: 24px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .createAt {
        width: 32%;
        line-height: 24px;
        text-align: right;
      }
    }
    .order-info {
      flex-direction: column;
      width: calc(100% - 40px);
      padding-left: 8px;
      .id-time {
        .name-info {
          .name {
            font-weight: 500;
            font-size: 14px;
            color: #666666;
            margin-right: 4px;
          }
        }
      }
    }
  }

  .order-id {
    align-items: center;
    justify-content: flex-start;
    .copy {
      width: 12px;
      height: 12px;
      cursor: pointer;
      margin-left: 4px;
    }
    text {
      line-height: initial;
    }
  }
  .work-info {
    background: #f8f8f8;
    display: flex;
    border-radius: 4px;
    padding: 8px;
    margin-bottom: 12px;
    align-items: center;
    width: 100%;
    max-height: 100px;
    overflow-y: auto;
    img {
      margin-right: 4px;
    }
    font-size: 14px;
    color: #999999;
    display: inline-block;
    .guideInquiry {
      padding: 2px 4px;
      font-weight: 400;
      font-size: 10px;
      color: #464646;
      background: #e2e2e2;
      border-radius: 2px;
      margin-right: 4px;
    }
    .pointer {
      cursor: pointer;
    }
  }

  .foot-line {
    color: #999999;
    align-items: center;
    justify-content: flex-end;
    .btns {
      text-align: right;
      flex: 1;
      .button {
        margin-left: 10px;
        border-radius: 4px;
      }
    }
  }
  &.will-allocate {
    padding-top: 0;
    .title {
      padding: 14px 16px;
      font-weight: 500;
      font-size: 14px;
      color: #303133;
      border-bottom: 1px solid #e8e8e8;
    }
    .will-allocate-list {
      padding: 12px 4px;
      border-bottom: 1px solid #e8e8e8;
      .hospital-info {
        margin-bottom: 12px;
        align-items: flex-start;
        justify-content: space-between;
        .hospital {
          align-items: flex-start;
          flex: 1;
          overflow: hidden;
          cursor: pointer;

          .hospital-avatar {
            margin-right: 6px;
          }
          .hospital-name {
            flex: 1;
            font-size: 14px;
            font-weight: bold;
            color: #495d87;
            line-height: 24px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .createAt {
          width: 32%;
          line-height: 24px;
          text-align: right;
        }
      }
    }
    .work-type {
      padding: 8px 0 4px;
      &-name {
        font-weight: 500;
        font-size: 14px;
        color: #666666;
      }
    }
  }
  .order-flag {
    padding: 1px 4px;
    border-radius: 2px;
    font-weight: 400;
    font-size: 10px;
    margin-left: 8px;
    flex-shrink: 0;
    &.times {
      border: 1px solid #ffa940;
      color: #ffa940;
    }
    &.answer {
      border: 1px solid #52c41a;
      color: #52c41a;
    }
  }
}
</style>
